export default __webpack_public_path__ + "static/media/myProfileAvatar.fd7207f7.png";